module.exports = __webpack_public_path__ + "img/grand-vitara-novel-white.9e06786c.png";